<template>
  <div style="text-align: left">
    <el-tabs v-model="activeName" type="border-card" style="border-radius: 5px">
      <el-tab-pane label="系统通告" name="notifications">
        <notification-list></notification-list>
      </el-tab-pane>

      <el-tab-pane label="优惠券管理" name="coupons">
        <coupon-management></coupon-management>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import NotificationList from "./notification/NotificationList";
import CouponManagement from "./coupon/CouponManagement";

export default {
  name: "Tools",
  components: {
    NotificationList,
    CouponManagement
  },

  data() {
    return {
      activeName: 'notifications',
    }
  },

  methods: {
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/tools/Tools.vue